import { ButtonSecondary } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface FormNavigatorExitActionProps {
    onExit: () => void;
}

export const FormNavigatorExitAction = ({ onExit }: FormNavigatorExitActionProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div className={'mb-4 flex justify-end px-4 sm:px-0'}>
            <ButtonSecondary
                className={'min-w-40'}
                dataTestId={'close-button'}
                onClick={onExit}
            >
                {t('common.close')}
            </ButtonSecondary>
        </div>
    );
};
